﻿import { createClient } from "./index";

(function attach() {
    const w = (globalThis as any);
    w.ETS = w.ETS || {};
    w.ETS.SipClient = { createClient };
})();
